import React from "react";
import { Box } from "app/components/common";
import AlgoliaSearch from "../SearchScreen/AlgoliaSearch";
import SearchButton from "../SearchScreen/SearchButton";
import normalize from "app/utils/normalize";
import { useDispatch } from "react-redux";
import {
  changeSearchType,
  onChangeSearch,
} from "@microdoing/shared/services/search/actions";
import SearchHits from "./SearchHits";
import theme from "app/Theme/Theme";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import HeaderFullScreen from "app/components/common/HeaderFullScreen";
import i18n from "@microdoing/shared/i18n";
import ArrowLeft from "app/components/Icons/Arrow/ArrowLeft";
import AlgoliaSearchButton from "../SearchScreen/AlgoliaSearchButton";

interface Props {}

const NewConversationScreen = ({ navigation }: Props) => {
  const [isSearching, setIsSearching] = React.useState(false);
  const dispatch = useDispatch();

  const searchConversation = () => {
    setIsSearching(true);
    dispatch(changeSearchType("message-user"));
  };

  const onResetSearch = () => {
    setIsSearching(false);
    dispatch(onChangeSearch(""));
  };

  const handleGoBack = () => {
    onResetSearch();
    navigation.goBack();
  };

  const insets = useSafeAreaInsets();

  return (
    <Box flex={1} style={{ paddingTop: insets.top }}>
      <HeaderFullScreen
        callbackOnPressLeft={handleGoBack}
        title={i18n.t("new-message")}
        leftIcon={
          <ArrowLeft
            color={theme.colors["neutral.900"]}
            height={normalize(30)}
            width={normalize(30)}
          />
        }
      />
      <AlgoliaSearch
        style={{
          borderRadius: 16,
          borderWidth: 1,
          borderColor: theme.colors["neutral.100"],
        }}
      >
        <Box
          flex={1}
          width="100%"
          borderWeight="thin"
          borderRadius={16}
          borderColor="brand.500"
        >
          <Box
            flexDirection="row"
            alignItems="center"
            justifyContent="center"
            paddingHorizontal="m"
            marginBottom="s"
          >
            <Box
              alignItems="center"
              justifyContent="center"
              flex={1}
              marginTop="sm"
            >
              <AlgoliaSearchButton
                autoFocus
                hasClearButton={isSearching}
                boxStyle={{ height: normalize(40) }}
                onPress={searchConversation}
                onClickOutside={onResetSearch}
                testID={"search-button-message-screen"}
              />
            </Box>
          </Box>
          <SearchHits onFinish={onResetSearch} />
        </Box>
      </AlgoliaSearch>
    </Box>
  );
};

export default NewConversationScreen;
